<template>
  <div class="modal-popup">
    <div class="modal fade" id="createPricingPeriodModal" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" v-if="editPricingPeriod">
          <div class="modal-header">
            <h3 class="title mt-2 ml-2">Fiyatlandırma Periyodu Oluştur</h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="la la-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="contact-form-action">
              <form method="post">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="input-box">
                      <label class="label-text">Başlangıç Tarihi</label>
                      <input class="form-control" v-model="editPricingPeriod.startDate" id="refundAmount" type="date" placeholder="">
                    </div>
                    <div class="input-box">
                      <label class="label-text">Bitiş Tarihi</label>
                      <input class="form-control" v-model="editPricingPeriod.endDate" id="refundReason" type="date" placeholder="">
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <button type="button" class="theme-btn theme-btn-gray mr-2" data-dismiss="modal">Cancel</button>
            <button v-if="editPricingPeriod.id && editPricingPeriod.id !== 0" @click="deletePeriod" type="button" class="theme-btn theme-btn-danger-rgb font-weight-bold font-size-15 color-text-2 mr-2">Delete</button>
            <button @click="accept" type="button" class="theme-btn">Onaylıyorum</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import messagePopupManager from "../../util/messagePopupManager";

export default {
  name: "CreatePricingPeriodPopup",
  computed:{
    editPricingPeriod:{
      get(){
        return this.$store.getters.getEditPricingPeriod;
      }
    },
    price:{
      get(){
        return this.$store.getters.getPrice;
      },
    },
  },
  methods:{
    deletePeriod(){
      this.$store.dispatch("deletePricingPeriod",this.editPricingPeriod.id).then(response => {
        Swal.fire({
          icon: 'success',
          title: 'Başarılı',
          text: '',
        })
        this.$store.commit("setSelectedPricingPeriodId", 0);
        this.$store.dispatch("loadPricingPeriodList", this.price.id);
        $("#createPricingPeriodModal").modal("hide");
      })
    },
    accept(){
      if(this.editPricingPeriod.startDate != null &&
          this.editPricingPeriod.endDate != null){

        this.editPricingPeriod.pricingTemplateId = this.price.id;

        if(this.editPricingPeriod.id && this.editPricingPeriod.id !== 0){
          this.$store.dispatch("updatePricingPeriod",this.editPricingPeriod).then(response => {
            Swal.fire({
              icon: 'success',
              title: 'Başarılı',
              text: '',
            })

            this.$store.dispatch("loadPricingPeriodList", this.price.id)
            $("#createPricingPeriodModal").modal("hide");
          }).catch(error => {
            messagePopupManager.showError("Hata", error.response.data.message);
          });
        }else{
          this.$store.dispatch("createPricingPeriod",this.editPricingPeriod).then(response => {
            Swal.fire({
              icon: 'success',
              title: 'Başarılı',
              text: '',
            })
            this.$store.dispatch("loadPricingPeriodList", this.price.id);
            $("#createPricingPeriodModal").modal("hide");
          }).catch(error => {
            messagePopupManager.showError("Hata", error.response.data.message);
          });
        }
      }else{
        $("#selectedAgency").addClass("error");
        $("#refundAmount").addClass("error");
        $("#refundReason").addClass("error");
      }

    }
  },
  updated() {
    setTimeout(function () {
      $(".select-contain-select").selectpicker('refresh');
    }, 100);
    $(".select-contain-select").selectpicker({
      size: 5,
      noneSelectedText: 'Select One'
    });
  }
}
</script>

<style scoped>

</style>